export default {
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  UPLOAD: "UPLOAD",
  SEARCH: "SEARCH",
  MANAGE_APPLICATION: "MANAGE_APPLICATION",
  MANAGE_ORG: "MANAGE_ORG",
  MANAGE_OPPORTUNITIES: "MANAGE_OPPORTUNITIES",
  MANAGE_PEOPLE: "MANAGE_PEOPLE",
  MANAGE_MESSAGES: "MANAGE_MESSAGES",
  MANAGE_BULK_UPLOAD: "MANAGE_BULK_UPLOAD",
  VIEW_REPORTS: "VIEW_REPORTS",
  MANAGE_SALES_ORG: "MANAGE_SALES_ORG",
  MANAGE_CONTENT: "MANAGE_CONTENT",
  MANAGE_SALES: "MANAGE_SALES",
  MANAGE_CANDIDATE: "MANAGE_CANDIDATE",
  MANAGE_JOB: "MANAGE_JOB",
  MANAGE_JOB_MESSAGE: "MANAGE_JOB_MESSAGE",
  MANAGE_MARKETING_CONTENT: "MANAGE_MARKETING_CONTENT",
  VIEW_ENGAGEMENT: "VIEW_ENGAGEMENT",
  MANAGE_GENERAL_COMMUNICATION_SETTINGS:
    "MANAGE_GENERAL_COMMUNICATION_SETTINGS",
  MANAGE_MY_TASKS: "MANAGE_MY_TASKS",
  MANAGE_CADENCES: "MANAGE_CADENCES"
};
